import { render, staticRenderFns } from "./DataCombinada.vue?vue&type=template&id=282ebacf"
import script from "./DataCombinada.vue?vue&type=script&lang=js"
export * from "./DataCombinada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports